import { endOfDay, format } from 'date-fns';

import type { CourseEntity } from '@modules/courses/entities';
import type { LapUpdateArgs, LapFinancialType } from '@modules/types/graphql';

export type UpdateLapFormValues = {
    course?: CourseEntity | null;
    from: Date | null;
    to: Date | null;
    isFree: boolean;
    canCertificate: boolean;
    canStudentEarlyAccess: boolean;
    canStudentViewOLTestResult: boolean;
    studentViewOLTestResultAfterSuccess: boolean;
    financialType?: string | null;
};

class UpdateLapRequest {
    from: LapUpdateArgs['from'];
    to: LapUpdateArgs['to'];
    isFree: LapUpdateArgs['isFree'];
    canCertificate: LapUpdateArgs['canCertificate'];
    canStudentEarlyAccess: LapUpdateArgs['canStudentEarlyAccess'];
    canStudentViewOLTestResult: LapUpdateArgs['canStudentViewOLTestResult'];
    studentViewOLTestResultAfterSuccess: LapUpdateArgs['studentViewOLTestResultAfterSuccess'];
    financialType: LapUpdateArgs['financialType'];

    constructor(values: UpdateLapFormValues) {
        this.from = values.from ? format(endOfDay(values.from), 'yyyy-MM-dd') : '';
        this.to = values.to ? format(endOfDay(values.to), 'yyyy-MM-dd') : '';
        this.isFree = values.isFree;
        this.canCertificate = values.canCertificate;
        this.canStudentEarlyAccess = values.canStudentEarlyAccess;
        this.canStudentViewOLTestResult = values.canStudentViewOLTestResult;
        this.studentViewOLTestResultAfterSuccess = values.studentViewOLTestResultAfterSuccess;
        this.financialType = (values.financialType as LapFinancialType) ?? null;
    }
}

export { UpdateLapRequest };
